module.exports = __webpack_public_path__ + "static/media/onlinephysiotherapy_drjim.c351d382.png";